<template>
  <div class="header-bar-menu-common public-width">
    <a-row>
      <a-col :span="7">
        <img src="./../../assets/imager/hqw_logo.png" alt="" />
      </a-col>
      <a-col :span="17">
        <ul class="menu" :key="current">
          <li v-for="(item, index) in tableData" :key="index" class="cell">
            <a
              @click="menuHandler(item, index)"
              :style="{ color: item.color }"
              >{{ item.text }}</a
            >
          </li>
        </ul>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "header-bar-menu",
  props: {
    menuList: Array,
  },
  data() {
    return {
      tableData: [
        {
          text: "现货大厅",
          url: "",
          color: "#005196",
        },
        {
          text: "工厂直达",
          url: "",
        },
        {
          text: "火拼团购",
          url: "",
        },
        {
          text: "老板直采",
          url: "",
        },
        {
          text: "行业头条",
          url: "",
        },
        {
          text: "好气金服",
          url: "",
        },
      ],
      current: +new Date(),
    };
  },
  created() {
    this.tableData =
      this.menuList && this.menuList.length ? this.menuList : this.tableData;
  },
  methods: {
    menuHandler(item, index) {
      this.tableData.forEach((res) => {
        res.color = "#333333";
      });
      this.tableData[index].color = "#005196";
      this.current = +new Date();
    },
  },
};
</script>

<style lang="less">
.header-bar-menu-common {
  height: 55px;
  line-height: 55px;
  .menu {
    display: flex;
    .cell {
      padding: 0 10px;
      a {
        color: #333333;
      }
      font-size: 16px;
    }
  }
}
</style>